<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="500px">
    <v-card flat>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Pilih Kandidat Sekolah yang Akan dipindah</v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container>
        <div style="height: 350px; overflow: scroll">
          <base-list-table
            :hideHeader="true"
            :loading="loading"
            :item="sekolahs"
            :total="sekolahs.length"
            :usePaging="false"
          >
            <template slot-scope="{ item }">
              <td>
                <v-card flat class="ma-0">
                  <v-list-item dense class="px-0" @click="onSelectSekolah(item)">
                    <v-list-item-content>
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-home</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0">
                          <h2 class="body-1 secondary--text">{{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}</h2>
                          <p class="body-2">
                            <strong>NPSN</strong> {{ $getDeepObj(item, 'sekolah.data.npsn') || '-' }} <br />
                            <strong>Alamat</strong> {{ $getDeepObj(item, 'sekolah.data.alamat') || '-' }} <br />
                          </p>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </td>
            </template>
          </base-list-table>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
export default {
  mixins: [list],
  props: {
    sekolahs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
    };
  },

  methods: {
    open() {
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelectSekolah(item) {
      this.resolve(item);
      this.dialog = false;
    },
  },
};
</script>
